import React, { useEffect, useState } from 'react';
import HeaderFooter from '../../src/components/layouts/headerfooter';
import { BlankSection } from '../../src/components/layouts/sections';
import MetaDecorator from '../../src/core/meta/MetaDecorator';
import ApplyNow from '../../src/components/applynowform';
import SimpleCentered from '../../src/components/simplecentered';
import axios from 'axios';
import { GetServerSideProps } from 'next'; // Import GetServerSideProps
import { getBaseUrl } from '../../src/util/serverUtils';

export default function Career({
    data,
    canonicalUrl,
}: {
    data: any;
    canonicalUrl:string | undefined | null;
}) {
    return (
        <>
            <HeaderFooter>
                <MetaDecorator
                    title={
                        data?.attributes?.seo
                            ? data?.attributes?.seo?.metaTitle
                            : 'Virtual gravity | Career'
                    }
                    description={
                        data?.attributes?.seo
                            ? data?.attributes?.seo?.metaDescription
                            : 'Virtual Gravity is an IT company based in Melbourne, Australia, with a development team in Nepal. We offer high-quality and cost-effective web and mobile application development services to clients worldwide. Contact us today to learn how we can help your business succeed through technology.'
                    }
                    imageUrl={
                        data?.attributes?.seo
                            ? data?.attributes?.seo?.metaTitle
                            : 'https://virtual-gravity.com/images/logo.svg'
                    }
                    imageAlt={
                        data?.attributes?.seo
                            ? data?.attributes?.seo?.media?.alt
                            : 'virtual-gravity-image'
                    }
                    keywords={
                        data?.attributes?.seo
                            ? data?.attributes?.seo?.keywords
                            : 'virtual-gravity'
                    }
                    canonicalUrl={canonicalUrl} // Set the canonical URL here
                />

                <BlankSection
                    ngClass={
                        'relative bg-no-repeat bg-cover bg-simple-centered h-full flex items-center flex-col mb-10 lg:min-h-[600px]'
                    }
                >
                    <SimpleCentered
                        heading1={`Wanna`}
                        headingHighlight={` join`}
                        heading2={` our team ?`}
                        description={`Wanna join our team? We’re looking for talented people with a passion for technology. Mail your resume or fill out the form.`}
                    />
                </BlankSection>

                <BlankSection ngClass={'bg-blend-screen relative'}>
                    <ApplyNow />
                </BlankSection>
            </HeaderFooter>
        </>
    );
}

// Add this code at the bottom of your page component
export const getServerSideProps: GetServerSideProps = async (context) => {
    //@ts-ignore
    const currentPath = getBaseUrl(context.req) + context.req.url;

    try {
        // Fetch data for the Career page
        const result = await axios.get(
            `${process.env.admin_url}/api/career?populate=*`
        );
        const data = result?.data?.data;

        return {
            props: {
                data,
                canonicalUrl: currentPath.includes('.json') ? null : currentPath, // Set the canonical URL
            },
        };
    } catch (error) {
        console.error('Error fetching data:', error);
        return {
            props: {
                data: null,
                canonicalUrl: currentPath.includes('.json') ? null : currentPath, // Set the canonical URL even in case of an error
            },
        };
    }
};
